"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _Radio = require("../Radio");
var _excluded = ["type", "rowIndex"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var SelectionBox = exports.default = /*#__PURE__*/function (_React$Component) {
  function SelectionBox(props) {
    var _this;
    (0, _classCallCheck2.default)(this, SelectionBox);
    _this = _callSuper(this, SelectionBox, [props]);
    (0, _defineProperty2.default)(_this, "unsubscribe", void 0);
    _this.state = _this.getCheckState(props);
    return _this;
  }
  (0, _inherits2.default)(SelectionBox, _React$Component);
  return (0, _createClass2.default)(SelectionBox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.subscribe();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.unsubscribe) {
        this.unsubscribe();
      }
    }
  }, {
    key: "subscribe",
    value: function subscribe() {
      var _this2 = this;
      var store = this.props.store;
      this.unsubscribe = store.subscribe(function () {
        _this2.setState(_this2.getCheckState(_this2.props));
      });
    }
  }, {
    key: "getCheckState",
    value: function getCheckState(props) {
      var store = props.store,
        defaultSelection = props.defaultSelection,
        rowIndex = props.rowIndex;
      var checked = false;
      var indeterminate = false;
      var state = store.getState();
      if (state.selectionDirty) {
        checked = state.selectedRowKeys.indexOf(rowIndex) >= 0;
      } else {
        checked = state.selectedRowKeys.indexOf(rowIndex) >= 0 || defaultSelection.indexOf(rowIndex) >= 0;
      }
      if (state.halfSelectedRowKeys) {
        indeterminate = state.halfSelectedRowKeys.indexOf(rowIndex) >= 0;
      }
      return {
        indeterminate: checked ? false : indeterminate,
        checked: checked
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        type = _this$props.type,
        rowIndex = _this$props.rowIndex,
        rest = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      var _this$state = this.state,
        checked = _this$state.checked,
        indeterminate = _this$state.indeterminate;
      if (type === 'radio') {
        return /*#__PURE__*/React.createElement(_Radio.Radio, (0, _extends2.default)({
          checked: checked,
          value: rowIndex
        }, rest));
      } else {
        return /*#__PURE__*/React.createElement(_Checkbox.default, (0, _extends2.default)({
          checked: checked,
          indeterminate: indeterminate
        }, rest));
      }
    }
  }]);
}(React.Component);